var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectionsInCollection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "collections_in_collection_icon",
    viewBox: "-18 0 40 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -8.5,
    cy: 15.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 15.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 1,
    height: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 1,
    height: 17,
    transform: "rotate(-45 3 3.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 1,
    height: 17,
    transform: "rotate(45 3 3.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionsInCollection);
export default __webpack_public_path__ + "static/media/collections_in_collection.766b6dd4.svg";
export { ForwardRef as ReactComponent };